module.exports = __webpack_public_path__ + "img/assertiveness_walkAway.77fd6709.png";